export default __webpack_public_path__ + "static/media/6.145f60bb.svg";